import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=636526c3&scoped=true"
import script from "./UserDisplay.vue?vue&type=script&lang=js"
export * from "./UserDisplay.vue?vue&type=script&lang=js"
import style0 from "./UserDisplay.vue?vue&type=style&index=0&id=636526c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636526c3",
  null
  
)

export default component.exports